import { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { GetNewsDetailsById_newsitems_newsfileimage as db_newsfileimage } from "src/api/generated/GetNewsDetailsById";
import { NetworkConfig } from "src/network/NetworkConfig";

export interface UseNewsImageUploadReturn {
    selectedFiles: File[];
    imageUrl: string;
    dbNewsFileImage: db_newsfileimage | undefined;
    hasFileChanges: boolean;
    setHasFileChanges: (value: boolean) => void;
    setDbNewsFileImage: (value: db_newsfileimage | undefined) => void;
    setImageUrl: (value: string) => void;
    getRootProps: (...args: any[]) => any;
    getInputProps: (...args: any[]) => any;
    onRemoveImageFile: () => void;
}

export const useNewsImageUpload = (
    initialDbFileImage: db_newsfileimage | undefined
): UseNewsImageUploadReturn => {
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [dbNewsFileImage, setDbNewsFileImage] = useState<db_newsfileimage | undefined>(initialDbFileImage);
    const [imageUrl, setImageUrl] = useState<string>(
        initialDbFileImage ? NetworkConfig.openThumbnailUrl + initialDbFileImage.fileid : ""
    );
    const [hasFileChanges, setHasFileChanges] = useState<boolean>(false);

    const onFileDrop = useCallback(
        async (acceptedFiles: File[]) => {
            setSelectedFiles([...selectedFiles, ...acceptedFiles]);
            const file: File = acceptedFiles[0];
            setImageUrl(URL.createObjectURL(file));
            setHasFileChanges(true);
        },
        [selectedFiles]
    );

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: onFileDrop,
        accept: {
            "image/jpeg": [".jpeg", ".jpg"],
            "image/png": [".png"],
            "image/gif": [".gif"]
        },
        maxFiles: 1
    });

    const onRemoveImageFile = useCallback(() => {
        const newFiles = [...selectedFiles];
        newFiles.splice(0, 1);
        setSelectedFiles(newFiles);
        setImageUrl("");
        setHasFileChanges(dbNewsFileImage !== undefined);
        setDbNewsFileImage(undefined);
    }, [selectedFiles, dbNewsFileImage]);

    return {
        selectedFiles,
        imageUrl,
        dbNewsFileImage,
        hasFileChanges,
        setHasFileChanges,
        setDbNewsFileImage,
        setImageUrl,
        getRootProps,
        getInputProps,
        onRemoveImageFile
    };
};
